import { get, post, put } from './_httpClient';

export async function getBMCIdentity() {
  return get('/clp/bumdes/bmc/identity');
}

export async function getBMCQuestions() {
  return get('/clp/bumdes/bmc/questions');
}

export async function saveDraftBMC(payload) {
  return post('/clp/bumdes/bmc/draft', payload);
}

export async function updateDraftBMC(bmcId, payload) {
  return put(`/clp/bumdes/bmc/${bmcId}/draft`, payload);
}

export async function submitBMC(bmcId, payload) {
  return put(`/clp/bumdes/bmc/${bmcId}/submit`, payload);
}

export async function getBMCResult(bmcId, version) {
  return get(`/clp/bumdes/bmc/${bmcId}/result${version ? `?version=${version}` : ''}`);
}

export async function getBMCAnswers(bmcId) {
  return get(`/clp/bumdes/bmc/${bmcId}/answers`);
}

export async function getAllBMCResults() {
  // Alias or implement as needed
  return get('/clp/admin/bumdes/bmc');
}

export async function getBMCHistory(bmcId) {
  return get(`/clp/bumdes/bmc/${bmcId}/history`);
}

export async function getBMCSurveyHistory(bmcId) {
  // Alias for getBMCHistory
  return get(`/clp/bumdes/bmc/${bmcId}/history`);
}

// ADMIN BMC
export async function getBMCSurveys({ batchId }) {
  return get(`/clp/admin/bumdes/bmc?batchId=${batchId || 45}`);
}

export async function getBMCSurveyDetail(bmcId) {
  return get(`/clp/admin/bumdes/bmc/${bmcId}`);
}

export async function updateBMCSurveyStatus(bmcId, payload) {
  return put(`/clp/admin/bumdes/bmc/${bmcId}/status`, payload);
}

export async function getBMCSurveyCompare(bmcId, v1, v2) {
  return get(`/clp/admin/bumdes/bmc/${bmcId}/compare?v1=${v1}&v2=${v2}`);
}

